import { render, staticRenderFns } from "./KitSkeleton.vue?vue&type=template&id=3bee123f&scoped=true&"
import script from "./KitSkeleton.vue?vue&type=script&lang=js&"
export * from "./KitSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./KitSkeleton.vue?vue&type=style&index=0&id=3bee123f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee123f",
  null
  
)

export default component.exports